import {BehaviorSubject} from 'rxjs';
import {BaseService} from '@esgi/core/service';
import {V2TeachersPagesHomeSectionsSubjectsController} from '@esgi/contracts/esgi';
import {SubjectType} from '@esgi/contracts/esgi/types/esgi.enums/subject-type';
import {SubjectLevel} from '@esgi/contracts/esgi/types/esgi.enums/subject-level';
import {SubjectTab} from '../types';
import {storage, SubjectTab as StoreSubjectTab} from '@esgi/main/libs/store';

export class SubjectService extends BaseService {
	public loaded$ = new BehaviorSubject(false);
	public subjects$ = new BehaviorSubject<SubjectTab[]>([]);
	private readonly controller = new V2TeachersPagesHomeSectionsSubjectsController();
	private subjectStorage = storage.subjects();

	constructor() {
		super();

		this.subjectStorage.get().subscribe((subjects) => {
			const sprSubjects = subjects.filter(({hidden}) => !hidden).map(x => {
				const sprSubject: SubjectTab = {
					canEdit: false,
					gradeLevels: [],
					hidden: false,
					id: x.id,
					level: x.level,
					name: x.name,
					testsCount: x.tests.length,
					type: x.type,
				};
				return sprSubject;
			});

			const allOption: SubjectTab = {id: 0, name: 'All', type: SubjectType.Personal, level: SubjectLevel.Teacher, testsCount: 0, hidden: false, canEdit: false, gradeLevels: []};
			this.subjects$.next([...sprSubjects, allOption]);

			if (!this.loaded$.value) {
				this.loaded$.next(true);
			}
		});
	}

	public override dispose() {
		this.controller.dispose();
		this.subjectStorage.dispose();
		super.dispose();
	}

	public get(subjectId: SubjectTab['id']) {
		return this.subjects$.value.find(({id}) => id === subjectId);
	}

	public getByIndex(index: number) {
		return this.subjects$.value[index];
	}

	private getSubjectType = (value: string | SubjectType) => {
		if (typeof value !== 'string') {
			return value;
		}
		return SubjectType[value];
	};

	private getSubjectLevel = (value: string | SubjectLevel) => {
		if (typeof value !== 'string') {
			return value;
		}
		return SubjectLevel[value];
	};
}

